import { RouteObject } from 'react-router-dom';
import { EDUCATION_LIST_PATH } from './EducationLinks';
import EducationDetailPage from './pages/EducationDetailPage';
import EducationListPage from './pages/EducationListPage';
import EducationPage from './pages/EducationPage';

export const EducationRoutes: RouteObject[] = [
  {
    path: '',
    children: [
      {
        index: true,
        element: <EducationPage />,
      },
      {
        path: EDUCATION_LIST_PATH,
        element: <EducationListPage />,
      },
      {
        path: ':id',
        element: <EducationDetailPage />,
      },
    ],
  },
];
